'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSameDate = isSameDate;
exports.isDisabled = isDisabled;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSameDate(firstDate, secondDate) {
    return (0, _moment2.default)(firstDate, 'DD/MM/YYYY').diff((0, _moment2.default)(secondDate, 'DD/MM/YYYY'), 'days', false) === 0;
}

function isDisabled(minDate, currentDate, maxDate) {
    var min = (0, _moment2.default)((0, _moment2.default)(minDate).format('DD/MM/YYYY'), 'DD/MM/YYYY');
    var max = (0, _moment2.default)((0, _moment2.default)(maxDate).format('DD/MM/YYYY'), 'DD/MM/YYYY');
    var current = (0, _moment2.default)((0, _moment2.default)(currentDate).format('DD/MM/YYYY'), 'DD/MM/YYYY');
    return !(min <= current && current <= max);
}